import { Formik, Form } from 'formik'
import { caseListContainerClasses } from '../../components/common/caseListClasses';
import * as Yup from 'yup'
import { useNavigate, useLocation } from "react-router-dom";
import { XInput } from '../../components';
import useAxios from '../../hooks/useAxios';
import Constants from '../../Constants';
import { confirm } from '../../utils/swal';
import XButton from '../../components/common/XButton';
import { formTitleClasses } from '../../components/common/formClasses';

const ResetPassword = () => {
    const { postData } = useAxios()
    const navigate = useNavigate();
    const location = useLocation();

    // super admin is mounted under /super/* so redirect accordingly
    const redirectPath = location.pathname.startsWith('/super') ? '/super/profile' : '/profile';

    const validationSchema = Yup.object().shape({
        password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters long'),
        confirmPassword: Yup.string().required('Confirm password is required').oneOf([Yup.ref('password')], 'Passwords must match')
    })

    const onSubmit = (values) => {
        values.token = Constants.getAuthtoken()?.token;
        postData(Constants.ApiUrl.auth.resetPassword, values).then((res) => {
            if (res.success) {
                confirm({ icon: "success", title: res.message }).then((result) => {
                    if (result.isConfirmed) navigate(redirectPath)
                });
            } else {
                confirm({ icon: "error", title: res.message });
            }
        }).catch(err => {
            confirm({ icon: "error", title: err.message });
        })
    }

    const backToProfile = () => navigate(redirectPath)

    const keyIconClasses = "absolute z-10 bottom-2 left-3 text-disabled";

    return (
        <section>
            <div className={`container ${caseListContainerClasses}`}>
                <div className="listing">
                    <Formik
                        initialValues={{
                            password: '',
                            confirmPassword: '',
                        }}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setErrors }) => {
                            onSubmit(values, setErrors)
                        }}
                    >
                        {(formik) => (
                            <Form>
                                <div className="p-0!">
                                    <h3 className={`${formTitleClasses} mb-6 text-2xl`}>Change Password</h3>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group relative">
                                                <span className={keyIconClasses}>
                                                    <i className="fa-solid fa-key"></i>
                                                </span>
                                                <XInput name="password" type="password" label="Password" placeholder="Enter New Password" className="pl-10!" {...formik.getFieldProps("password")} />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group relative">
                                                <span className={keyIconClasses}>
                                                    <i className="fa-solid fa-key"></i>
                                                </span>
                                                <XInput name="confirmPassword" type="password" label="Confirm password" placeholder="Enter Confirm Password" className="pl-10!" {...formik.getFieldProps("confirmPassword")} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-between items-center btm-btns'>
                                        <a onClick={backToProfile} className="text-primary! cursor-pointer"><i className='fa fa-arrow-left mr-2!'></i>Back to profile</a>
                                        <div className="flex items-center gap-5 text-center">
                                            <XButton variant="outlinePrimary" id="previous" onClick={backToProfile}>Cancel</XButton>
                                            <XButton type="submit" id="submit">Submit</XButton>
                                        </div>
                                    </div>
                                </div>
                            </Form>)}
                    </Formik>
                </div>
            </div>
        </section>
    )
}

export default ResetPassword;
